module.exports = __webpack_public_path__ + "static/media/travel.c3f667b1.svg";